import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import stateSelector from 'reduxModules/school/selectors'
import { schoolDispatchers as dispatchers } from 'reduxModules/school/dispatchers'
import Teacher from '../generic/ProfileSummary'

function Artists({ loadRandomArtists, loadRandomTestimonial, artists }) {
  useEffect(() => {
    loadRandomArtists(4)
  }, [loadRandomArtists, loadRandomTestimonial])
  return (
    <>
      <div className="artists">
        <div className="artists-holder">
          {artists.map((artist) => (
            <Teacher
              className="artist"
              key={`teacher-${artist.slug}`}
              name={artist.fullName}
              photo={artist.photo.boxThumb}
              slug={artist.slug}
            />
          ))}
        </div>
      </div>
      <div className="awards">
        <div>
          <div className="oscar-holder">
            30 <i className="icon-oscar" />
          </div>
          <h3>Nominations</h3>
        </div>
        <div>
          <div className="oscar-holder">
            12 <i className="icon-oscar" />
          </div>
          <h3>Academy Awards</h3>
        </div>
        <div>
          <div className="oscar-holder">
            230+
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130 80"
              width={50}
              height={50}
              style={{ margin: '0 10px' }}
            >
              <path d="M12,73.51q.2-34.74.39-69.38A3.21,3.21,0,0,1,15,1h0C23.4-.75,36.64-.31,45.63,3.14a35.46,35.46,0,0,1,16,11.65,37.34,37.34,0,0,1,16-11.15C86.12.4,99-.38,108.23,1A3.2,3.2,0,0,1,111,4.14h0V73.8A3.21,3.21,0,0,1,107.77,77a3.49,3.49,0,0,1-.74-.09A53.45,53.45,0,0,0,83.58,79.1a71,71,0,0,0-15.77,8.26,69.09,69.09,0,0,1,21.24-3.1,125.42,125.42,0,0,1,27.41,3.48V14.84h3.21a3.21,3.21,0,0,1,3.21,3.21V91.94a3.21,3.21,0,0,1-3.21,3.21,3.18,3.18,0,0,1-1-.17A121.77,121.77,0,0,0,89,90.65a61.89,61.89,0,0,0-25.76,5.26,3.39,3.39,0,0,1-3.64,0,61.86,61.86,0,0,0-25.76-5.26A121.77,121.77,0,0,0,4.24,95a3.18,3.18,0,0,1-1,.17A3.21,3.21,0,0,1,0,91.94V18.05a3.21,3.21,0,0,1,3.21-3.21H6.42v72.9a125.42,125.42,0,0,1,27.41-3.48,68.84,68.84,0,0,1,22.71,3.57A48.7,48.7,0,0,0,41,79.39c-7-2.3-17.68-3.07-25.49-2.4A3.21,3.21,0,0,1,12,74.06a5,5,0,0,1,0-.55ZM73.64,64.4a2.3,2.3,0,1,1-2.5-3.85,51.46,51.46,0,0,1,11.8-5.4,53.73,53.73,0,0,1,13-2.67,2.29,2.29,0,1,1,.25,4.58,49.42,49.42,0,0,0-11.79,2.46A46.73,46.73,0,0,0,73.64,64.4Zm.2-17.76a2.29,2.29,0,0,1-2.46-3.87,52.71,52.71,0,0,1,11.74-5.3A54.12,54.12,0,0,1,95.9,34.85a2.3,2.3,0,0,1,.25,4.59,49.3,49.3,0,0,0-11.63,2.4,48,48,0,0,0-10.68,4.8Zm.06-17.7a2.3,2.3,0,1,1-2.46-3.89,52.54,52.54,0,0,1,11.72-5.27,53.71,53.71,0,0,1,12.74-2.6,2.29,2.29,0,1,1,.25,4.58,49.35,49.35,0,0,0-11.59,2.39A47.91,47.91,0,0,0,73.9,28.94ZM51.74,60.55a2.3,2.3,0,1,1-2.5,3.85,46.73,46.73,0,0,0-10.72-4.88,49.42,49.42,0,0,0-11.79-2.46A2.29,2.29,0,1,1,27,52.48a53.73,53.73,0,0,1,13,2.67,51.46,51.46,0,0,1,11.8,5.4ZM51.5,42.77A2.29,2.29,0,0,1,49,46.64a48,48,0,0,0-10.68-4.8,49.3,49.3,0,0,0-11.63-2.4A2.3,2.3,0,0,1,27,34.85a54.12,54.12,0,0,1,12.78,2.62,52.71,52.71,0,0,1,11.74,5.3Zm-.06-17.72A2.3,2.3,0,1,1,49,28.94a47.91,47.91,0,0,0-10.66-4.79,49.35,49.35,0,0,0-11.59-2.39A2.29,2.29,0,1,1,27,17.18a53.71,53.71,0,0,1,12.74,2.6,52.54,52.54,0,0,1,11.72,5.27ZM104.56,7c-7.42-.7-18.06.12-24.73,2.65A30,30,0,0,0,64.7,21.46V81.72a76.76,76.76,0,0,1,16.72-8.66,62.85,62.85,0,0,1,23.14-2.87V7ZM58.28,81.1V21.37c-3.36-5.93-8.79-9.89-14.93-12.24-7-2.67-17.75-3.27-24.56-2.3l-.36,63.56c7.43-.27,17.69.68,24.52,2.91a54.94,54.94,0,0,1,15.33,7.8Z" />
            </svg>
          </div>
          <h3>Courses</h3>
        </div>
        <div>
          <div className="oscar-holder">
            1000+{' '}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              width="40"
              height="40"
              viewBox="0 0 105.765 122.88"
              style={{ margin: '0 10px' }}
            >
              <g>
                <path d="M82.872,90.81c-2.983-8.16-7.707-14.175-13.283-18.06c-3.772-2.629-7.914-4.284-12.133-4.97 c-4.236-0.686-8.583-0.408-12.747,0.828C35.573,71.323,27.33,78.716,22.903,90.81H82.872L82.872,90.81z M20.618,27.21h64.535 c0.346-2.922,1.154-13.713,1.119-16.995H19.497C19.462,13.498,20.27,24.288,20.618,27.21L20.618,27.21L20.618,27.21z M0.91,112.665 h9.567C10.222,85.12,22.648,68.03,38.027,61.466C22.637,54.9,10.205,37.79,10.478,10.214l-9.567,0c-0.501,0-0.909-0.46-0.909-1.025 L0,1.024C0,0.46,0.409,0,0.91,0h103.944c0.5,0,0.91,0.46,0.91,1.024v8.164c0,0.563-0.41,1.024-0.91,1.024h-9.57 c0.225,23.214-8.581,39.038-20.546,47.376c-2.188,1.522-4.543,2.832-6.994,3.873c2.446,1.049,4.81,2.354,6.992,3.88 c11.955,8.332,20.756,24.139,20.546,47.321l9.572,0.001c0.5,0,0.91,0.463,0.91,1.026v8.162c0,0.564-0.41,1.027-0.91,1.027H0.91 c-0.501,0-0.909-0.463-0.909-1.026v-8.162C0.001,113.128,0.41,112.665,0.91,112.665L0.91,112.665L0.91,112.665z" />
              </g>
            </svg>
          </div>
          <h3>Hours of Online Instruction</h3>
        </div>
        <div>
          <div className="oscar-holder">
            150K+
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 122.88 73.27"
              width={50}
              height={50}
              style={{ margin: '0 10px' }}
            >
              <g>
                <path
                  className="st0"
                  d="M104.27,58.88l-0.54-19.99l-32.85,9.49c-2.96,0.65-5.88,0.96-8.74,0.97c-3.07,0.01-6.09-0.32-9.06-0.97 L21.7,38.79v20.27c0.9,10.53,31.11,13.75,40.38,14.19c7.43,0.36,36.78-3.52,40.64-9.57C103.55,62.36,104.07,60.76,104.27,58.88 L104.27,58.88z M117.58,24.5v24.43h0.77c0.53,0,0.96,0.43,0.96,0.96v6.57c0,0.52-0.43,0.96-0.96,0.96h-0.77v2.3 c0.98,0.18,1.73,1.05,1.73,2.08v0c0,1.16-0.96,2.12-2.12,2.12h-3.79c-1.16,0-2.12-0.95-2.12-2.12v0c0-1.03,0.75-1.9,1.73-2.08v-2.3 h-0.77c-0.52,0-0.96-0.43-0.96-0.96v-6.57c0-0.53,0.43-0.96,0.96-0.96h0.77v-23L73.03,38.35c-7.24,1.72-14.48,1.84-21.72,0 L7.18,25.18l-3.99-1.19c-4.97-2.03-3.73-6.8,0.9-7.9L54,1.19c5.15-1.47,10.29-1.7,15.44,0l49.01,14.72 c5.33,1.3,6.38,6.23,0.18,8.26L117.58,24.5L117.58,24.5z"
                />
              </g>
            </svg>
          </div>
          <h3>Students</h3>
        </div>
      </div>
    </>
  )
}

export default connect(stateSelector, dispatchers)(Artists)
